import moment from 'moment';

const alertTypes = new Map([
  [1, 'yellow'],
  [2, 'orange'],
  [3, 'red'],
]);

export const all = (state) => {
  if (!state.all) return [];
  return state.all.map((item) => ({
    id: item.node.id,
    title: item.node.title,
    patient: item.node.user.subjectId,
    date: moment(item.node.activateDate).format('DD-MM-YYYY'),
    time: moment(item.node.activateDate).format('HH:mm'),
    type: alertTypes.get(item.node.emergencyLevel),
    module: item.node.component,
    message: item.node.message,
    action: item.node.actionMessage,
    patientId: item.node.user.patient.patientId.toString(),
    state: item.node.state,
    fullDate: item.node.activateDate
  }));
};

export const recent = (state) => {
  if (!state.recent) return [];
  return state.recent.map((item) => ({
    id: item.node.id,
    title: item.node.title,
    date: moment(item.node.activateDate).format('DD-MM-YYYY'),
    time: moment(item.node.activateDate).format('HH:mm'),
    type: alertTypes.get(item.node.emergencyLevel),
    module: item.node.component,
    message: item.node.message,
    action: item.node.actionMessage,
    state: item.node.state,
  }));
};

export const filters = (state) => state.filters || [];

export const patient = (state) => state.patient || { text: '', patient: '' };

export const fromDate = (state) => state.fromDate || '';

export const toDate = (state) => state.toDate || '';

export const limit = (state) => state.limit || 10;

export const offset = (state) => state.offset || 0;

export const pageInfo = (state) => state.pageInfo || {};

// @todo can probably remove some of these getters/data because we dont use state anymore for the alerts table
export const hasNextPage = (state, getters) => getters.pageInfo.hasNextPage || false;

export const hasPreviousPage = (state, getters) => getters.pageInfo.hasPreviousPage || false;

export const startCursor = (state, getters) => getters.pageInfo.startCursor || 0;

export const endCursor = (state, getters) => getters.pageInfo.endCursor || 0;

export const count = (state) => state.count || 0;

export const countAll = (state) => state.countAll || 0;
